export default "__VITE_ASSET__ChooYbQ8__"